import React from 'react';
import ReactDOM from 'react-dom';
import MarkerButton from './MarkerButton';

/**
 * Renders a hover tooltip for a stop marker (info only, no button)
 */
export function renderStopHoverTooltip(stop, marker, map) {
	const content = document.createDocumentFragment();

	ReactDOM.render(
		<div className="marker__tooltip marker__tooltip--stop">
			<h2 className="tooltipcontent__title">
				{stop.desc}, {stop.locality}
			</h2>
		</div>,
		content,
	);

	const tooltip = document.getElementById('tooltip');
	tooltip.innerHTML = '';
	tooltip.appendChild(content);
	map.getOverlayById('tooltip').setPosition(marker.getGeometry().getCoordinates());
	tooltip.style.display = '';
}

/**
 * Renders a selected tooltip for a stop marker (info + button)
 */
export function renderStopSelectedTooltip(stop, marker, map, addPoint) {
	const content = document.createDocumentFragment();

	ReactDOM.render(
		<div className="marker__tooltip marker__tooltip--stop">
			<h2 className="tooltipcontent__title">
				{stop.desc}, {stop.locality}
			</h2>
			<MarkerButton
				className="m-btn--addtoroute"
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					addPoint(stop);
					marker.set('selected', false);
					marker.changed();
					const tooltip = document.getElementById('tooltip-selected');
					if (tooltip) {
						tooltip.style.display = 'none';
					}
				}}
			>
				Zur Route hinzufügen
			</MarkerButton>
		</div>,
		content,
	);

	const tooltip = document.getElementById('tooltip-selected');
	tooltip.innerHTML = '';
	tooltip.appendChild(content);
	const mapOverlay = map.getOverlayById('tooltip-selected');
	mapOverlay.setPosition(marker.getGeometry().getCoordinates());
	tooltip.style.display = '';
}

/**
 * Renders a hover tooltip for a POI marker (info only, no button)
 */
export function renderPoiHoverTooltip(poi, marker, map) {
	const content = document.createDocumentFragment();

	ReactDOM.render(
		<div className="marker__tooltip marker__tooltip--poi">
			<h2 className="tooltipcontent__title">{poi.name}</h2>
		</div>,
		content,
	);

	const tooltip = document.getElementById('tooltip');
	tooltip.innerHTML = '';
	tooltip.appendChild(content);
	map.getOverlayById('tooltip').setPosition(marker.getGeometry().getCoordinates());
	tooltip.style.display = '';
}

/**
 * Renders a selected tooltip for a POI marker (info + button)
 */
export function renderPoiSelectedTooltip(poi, marker, map, addPoint) {
	const content = document.createDocumentFragment();

	ReactDOM.render(
		<div className="marker__tooltip marker__tooltip--poi">
			<h2 className="tooltipcontent__title">{poi.name}</h2>
			<MarkerButton
				className="m-btn--addtoroute"
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					addPoint(poi);
					marker.set('selected', false);
					marker.changed();
					const tooltip = document.getElementById('tooltip-selected');
					if (tooltip) {
						tooltip.style.display = 'none';
					}
				}}
			>
				Zur Route hinzufügen
			</MarkerButton>
		</div>,
		content,
	);

	const tooltip = document.getElementById('tooltip-selected');
	tooltip.innerHTML = '';
	tooltip.appendChild(content);
	map.getOverlayById('tooltip-selected').setPosition(marker.getGeometry().getCoordinates());
	tooltip.style.display = '';
}

/**
 * Renders a hover tooltip for a sharing marker (info only, no button)
 */
export function renderSharingHoverTooltip(station, marker, map, renderContent) {
	const content = document.createDocumentFragment();

	renderContent(station, content, 'tooltip');

	const tooltip = document.getElementById('tooltip');
	tooltip.innerHTML = '';
	tooltip.appendChild(content);
	map.getOverlayById('tooltip').setPosition(marker.getGeometry().getCoordinates());
	tooltip.style.display = '';
}

/**
 * Renders a selected tooltip for a sharing marker (info + button)
 */
export function renderSharingSelectedTooltip(station, marker, map, addPoint, renderContent) {
	const content = document.createDocumentFragment();

	const button = (
		<MarkerButton
			className="m-btn--addtoroute"
			onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();
				addPoint(station);
				marker.set('selected', false);
				marker.changed();
				const tooltip = document.getElementById('tooltip-selected');
				if (tooltip) {
					tooltip.style.display = 'none';
				}
			}}
		>
			Zur Route hinzufügen
		</MarkerButton>
	);

	renderContent(station, content, 'tooltip-selected', button);

	const tooltip = document.getElementById('tooltip-selected');
	tooltip.innerHTML = '';
	tooltip.appendChild(content);
	map.getOverlayById('tooltip-selected').setPosition(marker.getGeometry().getCoordinates());
	tooltip.style.display = '';
}

/**
 * Renders a hover tooltip for a route point marker (info only, no button)
 */
export function renderRoutePointHoverTooltip(point, marker, map, title) {
	const content = document.createDocumentFragment();

	ReactDOM.render(
		<div className="marker__tooltip marker__tooltip--sharing marker__tooltip--regiorad">
			<h2 className="tooltipcontent__title">{title}</h2>
		</div>,
		content,
	);

	const tooltip = document.getElementById('tooltip');
	tooltip.innerHTML = '';
	tooltip.appendChild(content);
	map.getOverlayById('tooltip').setPosition(marker.getGeometry().getCoordinates());
	tooltip.style.display = '';
}

/**
 * Renders a selected tooltip for a route point marker (info + remove button)
 */
export function renderRoutePointSelectedTooltip(point, marker, map, title, removePoint) {
	const content = document.createDocumentFragment();

	ReactDOM.render(
		<div className="marker__tooltip marker__tooltip--sharing marker__tooltip--regiorad">
			<h2 className="tooltipcontent__title">{title}</h2>
			<MarkerButton
				className="m-btn--removefromroute"
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					removePoint(point);
					marker.set('selected', false);
					marker.changed();
					const tooltip = document.getElementById('tooltip-selected');
					if (tooltip) {
						tooltip.style.display = 'none';
					}
				}}
			>
				Von Route entfernen
			</MarkerButton>
		</div>,
		content,
	);

	const tooltip = document.getElementById('tooltip-selected');
	tooltip.innerHTML = '';
	tooltip.appendChild(content);
	const mapOverlay = map.getOverlayById('tooltip-selected');
	mapOverlay.setPosition(marker.getGeometry().getCoordinates());
	tooltip.style.display = '';
}

/**
 * Renders a selected tooltip for a location marker (info + button)
 */
export function renderLocationSelectedTooltip(location, marker, map, addPoint, setLocationMarker) {
	const content = document.createDocumentFragment();

	ReactDOM.render(
		<div className="marker__tooltip">
			<h3 className="tooltipcontent__title">{location.name}</h3>
			<MarkerButton
				className="m-btn--addtoroute"
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					addPoint(location, false);
					marker.set('selected', false);
					marker.changed();
					const tooltip = document.getElementById('tooltip-selected');
					if (tooltip) {
						tooltip.style.display = 'none';
					}
					setLocationMarker(null);
				}}
			>
				Zur Route hinzufügen
			</MarkerButton>
		</div>,
		content,
	);

	const tooltip = document.getElementById('tooltip-selected');
	tooltip.innerHTML = '';
	tooltip.appendChild(content);
	map.getOverlayById('tooltip-selected').setPosition(marker.getGeometry().getCoordinates());
	tooltip.style.display = '';
}

/**
 * Clear selected tooltip
 */
export function clearSelectedTooltip() {
	const selectedTooltip = document.getElementById('tooltip-selected');
	if (selectedTooltip) {
		selectedTooltip.innerHTML = '';
		selectedTooltip.style.display = 'none';
	}
}

/**
 * Clear hover tooltip
 */
export function clearHoverTooltip() {
	const tooltip = document.getElementById('tooltip');
	if (tooltip) {
		tooltip.innerHTML = '';
		tooltip.style.display = 'none';
	}
}
